import { useEnv } from '@zenbusiness/application-commons-env';

const useBillingPath = () => {
  const { PARENT_SEGMENT = '/d' } = useEnv();

  if (PARENT_SEGMENT === `/d`) {
    return `${PARENT_SEGMENT}/account/payments`;
  }

  return `${PARENT_SEGMENT}/subscription-hub/billing/methods`;
};

export default useBillingPath;
